var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$store.state.firstTime)?_c('ModalHome'):_vm._e(),(_vm.$store.state.lightbox.active)?_c('Lightbox'):_vm._e(),_c('Header'),_c('div',{staticClass:"app-wrapper"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }